function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "molecule-40",
  transform: "translate(-1.834 -3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  "data-name": "Path 29",
  d: "M6.143,14.476,3,9.238,6.143,4h6.286l3.143,5.238-3.143,5.238Z",
  transform: "translate(0)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M6.143,34.476,3,29.238,6.143,24h6.286l3.143,5.238-3.143,5.238Z",
  transform: "translate(0 -9.524)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M24.143,24.476,21,19.238,24.143,14h6.286l3.143,5.238-3.143,5.238Z",
  transform: "translate(-8.571 -4.762)",
  fill: "none",
  stroke: "#487629",
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgNutrients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.332,
    height: 22.952,
    viewBox: "0 0 24.332 22.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrients);
export default __webpack_public_path__ + "static/media/nutrients.f21e1234.svg";
export { ForwardRef as ReactComponent };